import { IDs } from '../../../helpers/IDs';
import { lazyInject } from '../../../services/inversify';
import * as React from 'react';
import { TriggerService } from '../../../core/trigger/trigger_service';
import { WFormsTableWrapper } from '../../../core/table/WFormsTableWrapper';

interface DatenverwaltungKontaktFaqZuordnungProps extends React.ClassAttributes<any> {
    data: any;
}

export interface DatenverwaltungKontaktFaqZuordnungState {
    bundle: any;
    faq: any;
}

export class DatenverwaltungKontaktFaqZuordnung extends
    React.Component<DatenverwaltungKontaktFaqZuordnungProps, DatenverwaltungKontaktFaqZuordnungState> {

    constructor(props: any) {
        super(props);
        this.state = {
            bundle: null,
            faq: null
        };
        this.customFormatter = this.customFormatter.bind(this);
    }

    @lazyInject(TriggerService) private triggerService: TriggerService;

    componentDidMount(): void {
        this.init();
    }

    customFormatter(field: string, value: any, data: any, row: any): any {
        return field === 'faq' && ((this.state.faq || {})[value] || []).length > 1
            ? `${value} (${this.state.faq[value].indexOf(data.faq_orig || data.faq) + 1})`
            : value;
    }

    init(): void {
        const data: any = {};
        const faq: any[] = [];

        ((this.props.data || {})[IDs.ENT_KONTAKT_FAQ] || [])
            .sort((a: any, b: any) => a.tid - b.tid)
            .forEach((item: any) => {
                if (typeof data[item.name] === 'undefined') {
                    data[item.name] = [];
                }
                data[item.name].push(item.tid);
            });

        ((this.props.data || {})[IDs.ENT_KONTAKT_FAQ] || []).forEach((item: any, index: number) => {
            const name: string = item.name || null;
            faq.push(item);
            faq[index].name = data[name].length > 1
                ? `${name} (${data[name].indexOf(item.tid) + 1})`
                : name;
        });
        this.setState({ bundle: { faq }, faq: data });
    }

    render(): JSX.Element {
        if (!this.state.bundle) {
            return null;
        }

        return (
            <WFormsTableWrapper
                entity={IDs.ENT_KONTAKT_FAQ_ZUORDNUNG}
                module={IDs.MOD_ETOOL_ADMIN}
                actions={['add', 'edit', 'delete']}
                formLayout='flowV2'
                customClass='Custom-ETA'
                bundleFilterFunc={(bundle: any) => bundle.faq = this.state.bundle.faq || bundle.faq}
                onSaveDone={() => this.triggerService.fire('admin_reload', IDs.ENT_KONTAKT_FAQ_ZUORDNUNG)}
                onDelDone={() => this.triggerService.fire('admin_reload', IDs.ENT_KONTAKT_FAQ_ZUORDNUNG)}
                customFormatter={this.customFormatter}
                showColumnsHelp
            />
        );
    }
}
